import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children }) {
  return <span className="text-xs uppercase tracking-[0.25em] font-mono font-semibold text-[#4CB944]">{children}</span>;
}

export function SectionTitle({ eyebrow, title, subtitle, center = false }) {
  return (
    <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""} mb-12`}>
      {eyebrow && <div className="mb-3"><Overline>{eyebrow}</Overline></div>}
      <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 font-head">{title}</h2>
      {subtitle && <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function PrimaryLink({ to, children, testid, className = "" }) {
  return (
    <Link to={to} data-testid={testid}
      className={`inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#0F2A6B] text-white font-semibold hover:bg-[#0A1F52] transition-all hover:shadow-lg hover:shadow-[#0F2A6B]/25 ${className}`}>
      {children}
    </Link>
  );
}
